/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { getMinutesMs } from "@farmlands/utilities";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { isFarmlandsProApiAccountNumberApplied } from "../../../../services/farmlandspro-api";
import { selectCurrentFarmerAccount, selectIsThisTfo } from "../../../azure-b2c/storage";
import { QuoteStatus } from "../../storage/types";
import { fetchQuotes } from "../quotesApi";

export const getQuotesQueryKey = (accountNumber: string | undefined, status: string) =>
  ["quotes", accountNumber, status] as const;

export const useQuotes = (enabled: boolean) => {
  const selectedAccount = useSelector(selectCurrentFarmerAccount);
  const isStaff = !!useSelector(selectIsThisTfo);
  const accountNumber = selectedAccount?.accountNumber;

  const status = isStaff ? QuoteStatus.Requested : QuoteStatus.Offered;

  return useQuery({
    queryKey: getQuotesQueryKey(accountNumber, status),
    queryFn: () => fetchQuotes(accountNumber!, status),
    enabled: enabled && !!accountNumber && isFarmlandsProApiAccountNumberApplied(accountNumber),
    staleTime: getMinutesMs(5),
    gcTime: getMinutesMs(30),
  });
};
